module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/stat/chart.component.html
// module id = 945
// module chunks = 0